import * as React from 'react';
import * as ReactDOM from 'react-dom';
import SharingAcceptButton from '../components/SharingAcceptButton';
export default function addInteractiveElementsForReadingPane(element, item) {
    var button = React.createElement(SharingAcceptButton, { item: item });
    ReactDOM.render(button, element, null /* callback */);
    element.className = ''; // overwrite the server's OLK-hidden class
}
//# sourceMappingURL=addInteractiveElementsForReadingPane.js.map